
    <div class="dash-card MF-hide md-min" [ngClass]="{'hide-offline-content': !isOnline}">
        <div class="section">
            <h3 class="semi-bold">Scan Attendees</h3>
            <div class="instructions">
                Scan an attendee's membership QR code to verify attendees or add new attendees to this event.
            </div>
            <div class="app-buttons">
                <div class="btn-box right">
                    <button (click)="showScanner()" data-testid="088B10C5-8096-4D40-A26D-C90EA1A9B878"
                            type="button" role="button" class="btn primary-btn">Scan Attendee</button>
                    <button (click)="toggleAddAttendeeComponent()" type="button" role="button"
                        class="btn btn-white primary-color MF-slide-trigger md-max"
                        data-testid="C7207BB9-305C-421D-BC6F-87F3BEEB6673">Enter ID</button>
                </div>
            </div>
        </div>
    </div>
    <div class="dash-card MF-slide-out md-max"
        [ngClass]="{ 'MF-slide-is-visible': showAddComponent, 'hide-offline-content': !isOnline }">
        <div class="section">
            <button aria- type="button" role="button" class="MF-slide-close"
                (click)="toggleAddAttendeeComponent()" data-testid="D49A87D4-F244-4B6B-96D2-7612F3DF88B0">Click to close ID entry</button>
            <h3 class="semi-bold">Add Attendees by ID</h3>
            <div class="instructions">
                Enter the attendee's Registry ID number to add their verified attendance.
            </div>
            <div class="form-group">
                <label for="attendee_id">Attendee ID</label>
                <number-input [id]="'attendee_id'" [class]="'form-control input-lg'" [formControlReference]="attendeeId"
                    (onEnterPress)="addAttendee(addAttendeeModalRef)" data-testid="99ED4333-07A3-45A3-BE8E-E4DA379048A0" />
                <div class="validation-callout" *ngIf="showAddAttendeeErrorLabel">
                    Enter valid ID number
                </div>
            </div>
            <div class="app-buttons">
                <div class="btn-box right">
                    <button data-toggle="modal" data-target="#newattendee_confirmmodal_manual"
                        (click)="addAttendee(addAttendeeModalRef)" (keydown.enter)="addAttendee(addAttendeeModalRef)" [disabled]="disableAddAttendee"
                        type="button" role="button" class="btn primary-btn" data-testid="E5D49525-F1BF-46B5-99CE-647FF29C5584">Add Attendee</button>
                </div>
            </div>
        </div>
    </div>

<ng-template #addAttendeeModalRef>
    <attendance-add-modal (exitModal)="exitModal()" (confirmAttendee)="confirmAttendee($event)"
        [attendeeTypes]="attendeeTypes" [attendee]="attendee" [registryLabel]="registryLabel" [isPaidEvent]="isPaidEvent">
    </attendance-add-modal>
</ng-template>
<attendance-add-by-scanner #scanner (scanComplete)="onScanComplete($event)"></attendance-add-by-scanner>